import React, { useRef, useEffect, useState, memo, useCallback } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import NaviPaymentDetails from "./NaviPaymentDetails";
import SuccessFailureModal from "./SuccessFailureScreen";
import _, { flatten, get } from "lodash";
import {
  getInterstAmount,
  getUnitPrice,
  getOrderDetails,
  getAssetDetails,
  getThirdPartyData,
  getInvestmentAmount,
  // getUploadedDocsList,
  getUserPans,
  getPortfolio,
  getObUserState,
  getTimeline,
  purchaseNeft,
  getAllAssets,
  checkKycStatus,
  obPreKycInvestNow,
  createPurchaseOrder,
  cashfreeCheckPaymentStatus,
  sendToExchange,
  // signOroBond,
  // getUnlistedOrderDetails,
  purchaseNeftPaymentLink,
  getPaymentLink,
  getKycStatusKra
} from "../services/waitlist-service";
import InvestmentOverviewMain from "./InvestmentOverviewMain";
import InvestmentOverviewMainMob from "./InvestmentOverviewMainMob";
import { toast } from "react-toastify";
import SelectPaymentMode from "./SelectPaymentMode";
import NeftRtgsDetails from "./NeftRtgsDetails";
import ConsentPopup from "./ConsentPopup";
import done from "../assets/images/done.svg";
import failed from "../assets/images/failed.svg";
import pending from "../assets/images/pending.svg";
import StateCardBasic from "./StateCardBasic";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { userProfileService } from "../../user/services/profile";
// import { Mixpanel } from "./MixPanel";
import BondsAsset from "./BondsAsset";
import MldAssets from "./MldAssets";
import moment from "moment";
import IpoAssetNew from "./IpoAssetNew";
import BseFailedPopUp from "./BseFailedPopUp";
import SelectPaymentModeRfq from "./SelectPaymentModeRfq";
import useHypervergeVerification from './HypervergeHook';
import HypervergeSuccessPopUp from "./HypervergeSuccessPopUp";
import HypervergeFailurePopUp from "./HypervergeFailurePopUp";
import FailPopUpRfq from "./FailPopUpRfq";
import HypervergeUserCancelPopUp from "./HypervergeUserCancelPopUp";
import { load } from "@cashfreepayments/cashfree-js";
import CashfreePaymentStatus from "./cfPaymentStatus";
import { utils } from "../../core/helpers/utils";
import PriceDifferenceAlert from "./PriceDifferenceAlert";
import { subPartner } from "../../core/constant";
import PopupUccNseError from "./popup-ucc-nse-error";
import { initBranch, trackEvent } from "../../core/helpers/branchio";
import { initializeGTM, sendGTMEvent } from "../../core/helpers/gtm";
import ReactPixel from "react-facebook-pixel";

const OrobondsAsset = memo(function OrobondsAsset(props) {
  console.log("OrobondsAsset Rendered",props);
  // console.log(">> OrobondsAsset");
  const { hypervergeVerification, hypervergeSuccess,toggleHypervergeFailure, hypervergeFailure, toggleHypervergeSuccess , loaderHyperverge, errorsHyperverge, userCancelled, toggleUserCancelled, reinitiateHyperverge} = useHypervergeVerification();

  const history = useHistory();
  const queryParams = useParams();
  const location = useLocation();
  const investSectionRef = useRef(null);
  const txnRef = useRef(null);
  const [bondDetails, setBondDetails] = useState([]);
  const [units, setUnits] = useState();
  // const [docsList, setDocsList] = useState(null);
  const [unitPrice, setUnitPrice] = useState(null);
  // const [kycStatus, setKycStatus] = useState(true);
  const [userProfile, setUserProfile] = useState(null);
  const [assetDetails, setAssetDetails] = useState(null);
  const [thirdPartyData, setThirdPartyData] = useState({});
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  // const [showAssetTable, setShowAssetTable] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [dematPan, setDematPan] = useState(null);
  // const [showBanner, setShowBanner] = useState(false);
  const [openPaymentMode, setOpenPaymentMode] = useState(false);
  // const [openPaymentModeRfq, setOpenPaymentModeRfq] = useState(false);
  const [paymentMethod, setpaymentMethod] = useState(assetDetails?.userInRfqCug ? "neft" : "upi");
  const [openNeftRtgs, setOpenNeftRtgs] = useState(false);
  // const [openInstruction, setOpenInstruction] = useState(false);
  const [Coupons, setCoupons] = useState({});
  const [pfCoupon, setPfCoupon] = useState();
  const [couponsPer1k, setCouponsPer1k] = useState([]);
  const [realisedCouponsSum, setRealisedCouponsSum] = useState(0.0);
  const [modalType, setModalType] = useState("");
  const [succesModal, setSuccessModal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [signatureStatus, setSignatureStatus] = useState("");
  const [order, setOrder] = useState({});
  const [loader, setLoader] = useState(true);
  const [showConsent, setShowConsent] = useState(false);
  const [isKycDone, setIsKycDone] = useState(false);
  const [userState, setUserState] = useState({});
  const [portfolioValue, setPortfolioValue] = useState({});
  const [errors, setErrors] = useState([]);
  const [isTpdLoaded, setIsTpdLoaded] = useState(false);
  const [isOngoingOrder, setIsOngoingOrder] = useState(false);
  const [isNewJourney, updateNewJourney] = useState(false);
  // const [finalAmount, setFinalAmount] = useState(0.0);
  const [showFAQ, setShowFAQ] = useState(false);
  const [showCleanPrice, setShowCleanPrice] = useState(false);
  const [showYTM, setShowYTM] = useState(false);
  const [showOfferBenefit, setShowOfferBenefit] = useState(false)
  const [showMonthlyPayment, setShowMonthlyPayment] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [product, setProduct] = useState();
  const [productDetails, setProductDetails] = useState({});
  const [oppName, setOppName] = useState('');
  const [currYield, setCurrYield] = useState(false);
  // const [cleanPrice, setCleanPrice] = useState(0);
  const [paymentSuccessMixpanel, setPaymentSuccessMixpanel] = useState(false);
  const [priceResponse, setPriceResponse] = useState(null);
  const [cleanUpPrice, setCleanUpPrice] = useState(null);
  const [totalPayout, setTotalPayout] = useState(null);
  const [productName, setProductName] = useState('');
  const [isDisable, setIsDisable] = useState(true)
  const [isTxnAllowed, setIsTxnAllowed] = useState(true)
  const [oroLoader, setOroloader] = useState(true);
  const [maxAmt, setMaxAmt] = useState(false);
  const [productType, setProductType] = useState(null);
  const [bannerTextForReferred, setBannerTextForReferred] = useState("");
  const [recallTransactionApi, setRecallTransactionApi] = useState(false);
  const [ucc, setUcc] = useState();
  const [minUnit, setMinUnit] = useState();
  const [inputValueError, setInputValueError] = useState('')
  const [popUpFailedBse, setPopUpFailedBse] = useState(false);
  const [mldDetails, setMldDetails] = useState()
  // const [isinUnlisted, setIsinUnlisted] = useState()
  const [loaderForNEFT, setLoaderForNEFT] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentTried, setPaymentTried] = useState(false);
  const [tmpOrderId, setTmpOrderId] = useState();
  const [openRfqFailedPopUp, setOpenRfqFailedPopUp] = useState(false)
  // const [pgPurchaseCalled, setPgPurchaseCalled] = useState(false)
  const [pgPurchaseResponse, setPgPurchaseResponse] = useState()
  const [paymentLinkLoader, setPaymentLinkLoader] = useState(false)
  const [paymentLinkRes, setPaymentLinkRes] = useState("")
  const [cvlValidate, setCvlValidate] = useState(false);
  // const [allowTxnByCVL, setAllowTxnByCVL] = useState(false);
  const [exchange, setExchange] = useState("bse"); // bse [default], nse, etc.
  const [cashfree, setCashfree] = useState(null);
  const [cashfreeOrderId, setCashfreeOrderId] = useState("");
  const [cashfreeSessionId, setCashfreeSessionId] = useState("");
  const [cashfreePaymentStatusPopup, setCashfreePaymentStatusPopup] = useState(false);
  const [transactionStartTime, setTransactionStartTime] = useState("");
  const [priceChangePopup, setPriceChangePopup] = useState(false);
  const [cashfreePaymentStatusPopupData, setCashfreePaymentStatusPopupData] = useState(
    null
    /* 1. payment success */
    /* {
      status: "success",
      sendToExchange: false,
      title: "Payment Success",
      message: `
        <span>Order confirmation in Progress
        <br/>This usually takes 1-2 minutes</span>
        `,
      spinner: true,
      note: `<span>Do not close the browser</span>`,
      showCloseBtn: false
    } */
    /* 2. payment success but order on hold */
    /* {
      status: "failed",
      sendToExchange: false,
      title: "Order Registered",
      message: `
        <span><b>Your order will be placed when the market opens next.</b></span>
        <span>The market hours for Debt Segment is<br/>${"marketStartTime" - "marketEndTime"}</span>`,
      spinner: false,
      note: "",
      showCloseBtn: true
    } */
    /* 3. payment Failed */
    /* {
      status: "failed",
      sendToExchange: false,
      title: "Payment Failed",
      message: `<span>You can <a href="${process.env.REACT_APP_BASE_URL_ICM}/contact"
        target="_blank">contact us</a> for any queries
        <br/>
        <a href="mainto:connect@biddeasy.com">connect@biddeasy.com</a></span>`,
      spinner: false,
      note: "",
      showCloseBtn: true
    } */
    /* 4. Order success */
    /* {
      status: "success",
      sendToExchange: true,
      title: "Order Success",
      message: `
          <span><b>Your order has been processed<br/>successfully</b></span>
          <span>The securities will be settled in your account on ${rfqOrderDetails.settlementDate}</span>
        `,
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: true
    } */
    /* 5. Order failed */
    /* {
      status: "failed",
      sendToExchange: true,
      title: "Order Failed",
      message: `
        <span>Your order could not be processed
        <br/>Kindly re-try again or try later</span>`,
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: false,
      retry: false,
      count : retryCountAtExchange
    } */
  );
  const [retryCountAtExchange, setRetryCountAtExchange] = useState(0);  
  // This state will be set true when order is created for icmAdvisory partner
  const [isAdvisory, setIsAdvisory] = useState(false);
  const [subPartnerRedirectUrl, setSubPartnerRedirectUrl] = useState(subPartner.default.redirectUrl);
  const [isUccNse, setIsUccNse] = useState({
    created: false,
    popup: false,
    failed: {
      status: "failed",
      title: "Your account creation is pending",
      message: `<span>To know more, please contact us at <br/>
        <a href="mainto:connect@biddeasy.com">connect@biddeasy.com</a></span>
      `,
      spinner: false,
      orderId: typeof cashfreeOrderId != "undefined" ? cashfreeOrderId : "",
      note: "",
      showCloseBtn: true
    }
  });

  useEffect(() => {
    /* console.log(
       "\nucc: ", ucc,
      "\nexchange: ", exchange,
      "\nassetDetails: ", assetDetails,
      "\nopenPaymentMode: ", openPaymentMode
    ); */
    if (!cashfreeSessionId && isAdvisory && exchange === "nse" && Object.entries(assetDetails).length) { // isAdvisory
      /** isAdvisory for CF */
            const isAdvisoryParams = new URLSearchParams(window.location.href.split("?")[1]);
      const requiredParams = ["partner", "cf_sessionId", "orderId", "subPartner"];

      const result = requiredParams.filter(item => {
        console.log(item + ": " + isAdvisoryParams.get(item) + "\n");
        return isAdvisoryParams.get(item);
      });

      if (result.length === requiredParams.length) {
        setSuccessModal(false);
        setCashfreeSessionId(isAdvisoryParams.get("cf_sessionId"));
        setCashfreeOrderId(isAdvisoryParams.get("orderId"));
        setSubPartnerRedirectUrl(utils.subPartnerRedirectTo(isAdvisoryParams.get("subPartner")));
      }
      
      /* console.log(
        "result==: ", result,
        "\nucc: ", ucc?.exchange,
        "\nassetDetails: ", assetDetails,
        "\nopenPaymentMode: ", openPaymentMode
      ); */
    }
  }, [isAdvisory, ucc, assetDetails, openPaymentMode])

  const paymentStatuses = {
    success: {
      status: "success",
      sendToExchange: false,
      title: "Payment Success",
      message: `
        <span>Order confirmation in Progress
        <br/>This usually takes 1-2 minutes</span>
      `,
      spinner: true,
      note: `<span>Do not close the browser</span>`,
      showCloseBtn: false
    },
    pending:{
      status: "pending",
      sendToExchange: false,
      title: "Payment Success",
      message: `
        <span>Order confirmation in Progress
        <br/>This usually takes 1-2 days</span>
      `,
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: true,
      reloadPage: true
    },
    /* successButOnHold: {
      status: "failed",
      sendToExchange: false,
      title: "Order Registered",
      message: `
        <span><b>Your order will be placed when the market opens next.</b></span>
        <span>The market hours for Debt Segment is
        <br/>${moment(assetDetails?.marketStartTime, "HH:mm").format("hh:mm A")} - ${moment(assetDetails?.marketEndTime, "HH:mm").format("hh:mm A")}</span>
      `,
      spinner: false,
      note: "",
      showCloseBtn: true,
      reloadPage: true
    }, */
    failed: {
      status: "failed",
      sendToExchange: false,
      title: "Payment Failed",
      message: `<span>You can <a href="${process.env.REACT_APP_BASE_URL_ICM}/contact"
        target="_blank">contact us</a> for any queries
        <br/>
        <a href="mainto:connect@biddeasy.com">connect@biddeasy.com</a></span>
      `,
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: true
    }
  }

  const orderStatuses = {
    success: {
      status: "success",
      sendToExchange: true,
      title: "Order Success",
      message: `
        <span><b>Your order has been processed<br/>successfully</b></span>
        <span>The securities will be settled in your account on ${"--"}</span>
      `, /* ${res.data.rfqOrderDetails.settlementDate} */
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: true,
      reloadPage: true
    },
    successButOnHold: {
      status: "onhold",
      sendToExchange: false,
      title: "Order Registered",
      message: `
        <span><b>Your order will be placed when the market opens next.</b></span>
        <span>The market hours for Debt Segment is
        <br/>9:30AM - 5:00PM</span>      
      `/* ${moment(assetDetails?.marketStartTime, "HH:mm").format("hh:mm A")} - ${moment(assetDetails?.marketEndTime, "HH:mm").format("hh:mm A")} */,
      spinner: false,
      note: "",
      showCloseBtn: true,
      reloadPage: true
    },
    failedAndRetry: {
      status: "failed",
      sendToExchange: true,
      title: "Order Failed",
      message: `
        <span>Your order could not be processed
        <br/>Kindly re-try again or try later</span>
      `,
      spinner: false,
      orderId: cashfreeOrderId,
      note: "",
      showCloseBtn: false,
      retry: false,
      count: retryCountAtExchange
    }
  }

  /* useEffect(()=>{
    console.log("assetDetails", assetDetails, "\n",  moment(assetDetails?.marketEndTime, "HH:mm").format("hh:mm A"));
  }) */

  /* const goToRazorPay = (order) => {
    setSuccessModal(false);
    setSignatureStatus("");
    if (isAdvisory) {
      history.replace(`/biddeasy-asset/${productType}/${product}?partner=icmAdvisory`);
    } else {
      history.replace(`/biddeasy-asset/${productType}/${product}`);
    }

    let razorPay = createRazorpayInstance(order);
    if (razorPay) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: "BIDD_RZP",
            payload: {
              order: order,
              productName: assetDetails?.displayName
            }
          })
        )
      } else {        
        razorPay.open();

        razorPay.on(
          "payment.success",
          (response) => {
            console.log("Payment Success (Response):", response);
          },
          (err) => {
            console.log("Payment Success (Error):", err);
          }
        );

        razorPay.on(
          "payment.failed",
          (response) => {
            console.log("Payment Failed (Response):", response);
          },
          (err) => {
            console.log("Payment Failed (Error):", err);
          }
        );
      }
    }
  }; */

  useEffect(() => {
    /**
   * Hide Header & Footer for webview in mobile app - required query parameter "isSourceApp=true".
   */
    const searchParams = new URLSearchParams(window.location.href.split("?")[1]);

    if (searchParams.get('isSourceApp')) {
      const $style = document.createElement("style");
      $style.id = "sourceApp";
      $style.setAttribute('type', 'text/css');
      document.head.appendChild($style);
      $style.innerHTML = `
        .container.site-header{display:none;transition:display 0.1s;}
        .mobile-menu{display:none!important;transition:display 0.1s;}
        .navi-asset-detail-main{margin-top:0px!important;padding-top:0px;}
        .navi-asset-detail-main .state-banner-main{margin-top:0px;}
        .navi-asset-detail-main .consult-banner{bottom:0px;}`;
    }
    return () => {
      try {
        const objStyle = document.head.querySelectorAll('style#sourceApp');
        objStyle[0].remove();
      } catch (ex) {
        console.log('isSourceApp unmount ' + ex);
      }
    }
  }, [])

  useEffect(() => {
    if (props?.pan && props?.pan.length) {
      let payload = { payload: utils.encryptedPayload({
        pan: props?.pan
      })}
      getKycStatusKra(
        utils.getPKey() ? payload : payload.payload,
        { "X-product": `orobonds:default` })
        .then((result) => {
          const res = utils.parsePayload(result);
          if (!res | !res.success) {
            setCvlValidate(false);
            // setAllowTxnByCVL(false);
          }
          if (res.success && res.data) {
            if (!res?.data?.txnAllowed) {
              // setAllowTxnByCVL(false);
            } else {
              // setAllowTxnByCVL(true);
            }
            if (res?.data?.description?.action.toLowerCase() === "invalid") {
              setCvlValidate(false);
            } else if (res?.data?.description?.action?.toLowerCase() === "valid") {
              setCvlValidate(true);
            }
          } 
        }
      )
    }
  }, [props?.pan])

  useEffect(()=>{
    if(paymentTried === true){
      toggleRfqFailedPopUp()
    }
  },[paymentTried])

  const toggleRfqFailedPopUp = () =>{
    onPaymentChange("neft")
    setOpenRfqFailedPopUp(!openRfqFailedPopUp)
    setPaymentLinkLoader(false)
    setOpenPaymentMode(!openPaymentMode)
  }

  const canclePaymentModelRfq = () =>{
    setOpenPaymentMode(!openPaymentMode)
  }

  const getCouponSum = () => {
    let sum = 0;
    let finalSum = 0.0;
    if (couponsPer1k && couponsPer1k?.length) {
      couponsPer1k.map(coupon => {
        let per1k = parseFloat(coupon.CouponPer1k);
        sum += (per1k.toFixed(4)) * units;
      })
    }
    finalSum = sum;
    setTotalCoupons(finalSum);
  }


  const redirectProspectus = (prospectusLink) => {
    window.open(
      prospectusLink,
      "_blank",
      "noopener"
    );
  };

  const toggleSuccesModal = (res) => {
    setSuccessModal(res);
    setPaymentStatus("");
    setSignatureStatus("");
    if (isAdvisory && (paymentMethod === "netbanking" || paymentMethod === "upi") && !assetDetails.userInRfqCug) {
      window.location.href = `${subPartnerRedirectUrl}/orders/${order.orderId}/payments/status/?status=${res ? 'success' : 'failure'}`;
    } else if ((isAdvisory && paymentMethod === "neft") && !assetDetails.userInRfqCug) {
      window.location.href = `${subPartnerRedirectUrl}/orders/${order.orderId}/payments/status/?status=success`;
    } else {
      history.replace(`/biddeasy-asset/${productType}/${product}`);
      window.location.reload();
    }
  };

  const redirectToAbout = () => {
    window.open("https://www.orowealth.com/about/", "_blank", "noopener");
  };

  /* const createRazorpayInstance = (order) => {
    let options = {
      name: "Bidd",
      amount: order.amount,
      order_id: order.orderId,
      currency: order.currency,
      theme: {
        color: "#283A97",
      },
      personalization: 'false',
      modal: {
        ondismiss: function () {
          setIsOngoingOrder(false);
        },
      },
      prefill: {
        name: order.name,
        email: order.email,
        contact: order.phone,
      },
      redirect: true,
      key: order.key,
      callback_url: order.url,
      description: "Bidd",
      image:
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjcyNzI5NSAwLjcyNzI2NEgxNy4yNzI4VjE3LjI3MjdIMC43MjcyOTVWMC43MjcyNjRaTTIuOTMzMzkgMi45MzMyOEgxNS4wNjY3VjQuMzI5NTVDMTAuNTEwNiA0Ljk0Mjk3IDcuNDc3ODYgOC44ODI2NCA2LjkzMTg0IDEwLjkzMDJDNS43NDk4NiA4Ljk2MDI4IDMuOTAwNzEgOC4yODI5NSAyLjkzMzM5IDcuOTQ1MDRWMi45MzMyOFpNMi45MzMzOSAxMC42NjIzVjE1LjA2NjZINS45NjYxM0M1LjkxODczIDEzLjgwOTYgNS4yNjYzMyAxMS41OTMgMi45MzMzOSAxMC42NjIzWk04LjQ1NzQ2IDE1LjA2NjZIMTUuMDY2N1Y2LjY5MjI0QzEyLjg1NjkgNy4zMDA4NSA4LjY5OTQ5IDkuNzQ3NDMgOC40NTc0NiAxNS4wNjY2WiIgZmlsbD0iIzI4M0E5NyIvPgo8L3N2Zz4K",
    };
    { process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent(window.location.pathname + window.location.hash,
        "Investment_Initiated"
      );
    }
    // facebook pixel integration
    // ReactPixel.track('PURCHASE INITIATED');
    return new window.Razorpay(options);
  }; */

  const fetchTransactions = useCallback((productName) => {
    getTimeline({ "X-product": `orobonds:${productName}` }).then((result) => {
      const respTime = utils.parsePayload(result);

      if (respTime && respTime.success) {
        if (respTime.data && respTime.data.length) {
          // setShowBanner(true);
          setTransactions([...respTime.data]);
        }
      } else {
        toast.error("Error: orobond timeline: Something went wrong");
      }
    });
  }, [transactions]);

  const recallTransaction = () => {
    setRecallTransactionApi(!recallTransactionApi)
  }

  useEffect(() => {
        if (queryParams.productType !== "unlisted") {
      let queryParam = queryParams && queryParams.product &&
        queryParams.product.split('?')[0];
      fetchTransactions(queryParam)
    }
  }, [recallTransactionApi])

  const onPaymentChange = (val) => {
    if (paymentTried) {
      setpaymentMethod("neft");
    } else setpaymentMethod(val);
  };

  function updateUserState(email, pan, productName) {
    return checkKycStatus(email, pan, { "X-product": `orobonds:${productName}` })
      .then(result => {
        const docStatusResp = utils.parsePayload(result);
        if (!docStatusResp || !docStatusResp.success) {
          toast.error("Something went wrong, unable to get kyc details!");
          return;
        }
        if (docStatusResp.results &&
          !docStatusResp.results.allDocUploadedForThirdParty) {
          updateNewJourney(true);
        } else {
          getObUserState(
            {
              email: email,
              pan: pan,
            },
            product,
            { "X-product": `orobonds:${productName}` }
          ).then(
            (result) => {
              const response = utils.parsePayload(result);
              if (response && response.success) {
                setIsKycDone(response.results.obUserApproved);
                setUserState({ ...response.results });
              }
            },
            (err) => {
              toast.error("Something went wrong, unable to get kyc details!");
            }
          );
        }
      });
  }

  useEffect(() => {
    if (minUnit) {
      setUnits(minUnit)
    }
  }, [minUnit, assetDetails])

  const closeMonthlyPaymentModal = () => {
    setShowMonthlyPayment(!showMonthlyPayment);
  }

  const closeFAQModal = () => {
    setShowFAQ(!showFAQ);
  };

  const closeCleanPriceModal = () => {
    setShowCleanPrice(!showCleanPrice);
  }

  const closeYTMModal = () => {
    setShowYTM(!showYTM);
  };

  const closeShowOfferBenefit = () => {
    setShowOfferBenefit(!showOfferBenefit)
  }

  const openShowOfferBenefit = () => {
    setShowOfferBenefit(!showOfferBenefit)
  }
  const closePaymentModal = () => {
    setShowPayment(!showPayment);
  };
  const toggleHvInitiateModal = () => {
    setIsModalOpen(!isModalOpen)
  }


  const openPaymentRtgs = () => {
    togglePaymentModal()
    setOpenPaymentMode(true)
  }

  const getBannerForNewUser = (signedUpOn, isReferredUser) => {
    let currentDate = moment();
    let signedUpDate = moment(signedUpOn);
    let bannerText = "Your KYC is not verified, it takes a few minutes to get you started.";
    let daysDiff = currentDate.diff(signedUpDate, 'days');
    let limit = 7;
    if (!thirdPartyData.userInHypervergeCug && daysDiff < limit) {
      if (isReferredUser) {
        bannerText = "Finish your KYC within " + (limit - daysDiff) + ` days and get ${isNewJourney && !props?.isUserObInvested ? "upto 0.50" : priceResponse?.referralBenefits?.discountInPercForUser ? (priceResponse?.referralBenefits?.discountInPercForUser).oroNumber(2, true) : "0"}% offer benefit on 1st investment.`
      } else {
        bannerText = "Finish your KYC within " + (limit - daysDiff) + ` days and get ${isNewJourney && !props?.isUserObInvested ? "upto 0.50" : priceResponse?.referralBenefits?.discountInPercForUser ? (priceResponse?.referralBenefits?.discountInPercForUser).oroNumber(2, true) : "0"}% offer benefit on 1st investment.`
      }
    }
    if (thirdPartyData.userInHypervergeCug && thirdPartyData.enhancedKycStaus === 'underProcess') {
      bannerText = "Thank you for sharing your details, your KYC is under verification.";
    }if(thirdPartyData.userInHypervergeCug && thirdPartyData.enhancedKycStaus === 'rejected'){
      bannerText = "Your KYC is rejected";
    }
    // if(thirdPartyData.userInHypervergeCug && thirdPartyData.enhancedKycStaus === 'approved'){
    //   bannerText = "Your KYC is completed ";
    // }
    setBannerTextForReferred(bannerText)
  }

  const reInitiateHyperverge = () =>{
    reinitiateHyperverge()
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ 
          action: "BIDD_HV", 
          data: {
            assetCode: assetDetails?.product,
            productType: assetDetails?.productType
          }
        })
      )
    } else {
      return hypervergeVerification();
    }
  }

  useEffect(() => {
    if (thirdPartyData && Object.keys(thirdPartyData).length) {
      if (isNewJourney) {
        getBannerForNewUser(
          thirdPartyData.signedUpOn,
          thirdPartyData.isReferredUser
        );
      }
    }
  }, [isNewJourney, thirdPartyData]);

  useEffect(() => {
    initializeGTM();
    ReactPixel.init('1402347907589394');
    if (queryParams.productType !== "unlisted") {
      let queryParam = queryParams && queryParams.product &&
        queryParams.product.split('?')[0];
      setProductType(queryParams && queryParams.productType)
      let productName;
      let ISIN;
      if (queryParam) {
        productName = queryParam;
        setProduct(queryParam);
      } else {
        productName = queryParams.product;
        setProduct(queryParams.product);
      }
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("/orobondsAsset", "Postlogin_orobonds_asset_landing");
      }
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
      setLoader(true);
      if (queryParams && queryParams.product) {
        let redirectionUrl = queryParams.product.split('?')[1];
        let utmParams = new URLSearchParams(redirectionUrl);
        let source = 'web';
        let userInterest = `waitlist_${productName}`;
        if (redirectionUrl) {
          if (utmParams.get('utm_source')) {
            // userProfileService.sentUserData(source, userInterest, '?' + redirectionUrl);
            if (!sessionStorage.getItem("userInterest")) {
              userProfileService.sentUserData(source, userInterest, '?' + redirectionUrl).then((res) => {
                if (res?.success) {
                  sessionStorage.setItem("userInterestWaitlist", userInterest);
                }
              });
            }
          }
        } else {
          // userProfileService.sentUserData(source, userInterest);
          if (!sessionStorage.getItem("userInterest")) {
            userProfileService.sentUserData(source, userInterest).then((res) => {
              if (res?.success) {
                sessionStorage.setItem("userInterestWaitlist", userInterest);
              }
            });
          }
        }
      }

      let isUserStatesLoaded = false;
      setLoader(true)
      getAllAssets({ "X-product": `orobonds:${productName}` }, { product: productName })
        .then(result => {
          const bonds = utils.parsePayload(result);
          if (!bonds || !bonds.success) {
            return toast.error("Error: Unable to fetch bonds details");
          }
          if (bonds && bonds.data && bonds.data.length) {
            let data = bonds?.data.find(e => e.bondId);
            ISIN = data.ISIN;
            setOppName(data?.issuer);
            // console.log("data ", bonds);
            setProductDetails({ ...data });
            getAssetDetails(ISIN, { "X-product": `orobonds:${productName}` }).then(
              (result) => {
                const res = utils.parsePayload(result);

                if (res) {
                  setAssetDetails(res.data);
                  setMldDetails(res.data)
                  setMinUnit(res.data.minUnits)
                  setUnits(res.data.minUnits)
                  setIsDisable(res.data.showOnBrowse)
                  setIsTxnAllowed(res.data.isTxnAllowed)
                  // setOroloader(false)
                  // setLoader(false)
                  if (res.data.rfqExchangeType) {
                    setExchange(String(res.data.rfqExchangeType).toLowerCase());
                  }
                }
              },
              (err) => {
                toast.error("Asset Details (Error):", err);
              }
            );
          };
        });
      if (queryParams.productType !== "unlisted") {
        getAllAssets({ "X-product": `orobonds:${productName}` }, { product: !productName ? 'navi0' : productName })
          .then(result => {
            const bonds = utils.parsePayload(result);
            if (!bonds || !bonds.success) {
              return toast.error("Error: Unable to fetch bonds details");
            }
            if (bonds && bonds.data && bonds.data.length) {
              setBondDetails(bonds.data[0]);
            }
          });
        getUserPans({ "X-product": `orobonds:${productName}` }).then((result) => {
          const response = utils.parsePayload(result);
          if (response && response.success) {
            if (response.data && response.data.length) {
              let email = response.data[0].email;
              let pan = response.data[0].pan;
              /*
                if /getPans has PAN and email in its response
                then call /status using those values and populate
                userStates.
              */
              if (email && pan) {
                isUserStatesLoaded = true;
                updateUserState(email, pan, productName);
              }
              setUserProfile(response.data[0]);
              setDematPan(response.data[0].pan);
              setErrors([
                ...flatten(
                  get(response, "data", []).map((p) =>
                    p.rejectRemarks ? p.rejectRemarks : []
                  )
                ),
              ]);
            }
          } else {
            toast.error("Something went wrong, unable to fetch user details!");
          }
          getThirdPartyData({ "X-product": `orobonds:${productName}` }).then(
            (result) => {
              const res = utils.parsePayload(result);
              setIsTpdLoaded(true);
              if (res && res.success) {
                setUcc(res.data.ucc)
                /*
                  if data: [] in /getPans response then call /status 
                  using pan and email provided in response of /thirdpartyData
                */
                if (!isUserStatesLoaded) {
                  if (res.data && res.data.pan && res.data.email) {
                    updateUserState(res.data.email, res.data.pan, productName);
                  } else {
                    /*
                      if response of /thirdpartyData doesn't have email and pan
                      then consider this flow as fresh user journey
                    */
                    updateNewJourney(true);
                  }
                }
                if (res.data.ucc?.nse?.uccCreated) { // check if user in UCC.NSE.
                  console.log("ucc nse created ", res.data.ucc?.nse?.uccCreated);
                  setIsUccNse({ ...isUccNse, created: true });
                }
              } else {
                return toast.error(
                  "Something went wrong, unable to fetch user details!"
                );
              }
              setThirdPartyData({ ...res.data });
              if (res.data && res.data.pan) {
                /* getUploadedDocsList({
                  payload: utils.encryptedPayload({pan: res.data.pan})
                }, { "X-product": `orobonds:${productName}` }).then(
                  (response) => {
                    setDocsList(utils.parsePayload(response.data));
                  },
                  (err) => {
                    toast.error("Uploaded Docs (Error):", err);
                  }
                ); */

                if (queryParams && queryParams.product) {
                  const qp = new URLSearchParams(
                    queryParams.product.split('?')[1]
                  );
                  const orderId = qp.get("orderId");
                  const paymentStatus = qp.get("paymentStatus");
                  const message = qp.get("message");

                  let order = null;

                  if (orderId) {
                    setLoader(true);
                    setIsOngoingOrder(true);
                    setModalType("signature");
                    setStatusMessage(message);
                    setSignatureStatus(qp.get("status"));

                    if (qp.get("status") === "success") {
                      getOrderDetails(orderId, { "X-product": `orobonds:${productName}` }).then(
                        (orderRes) => {
                          if (orderRes && !orderRes.success) {
                            toast.error(
                              orderRes.message
                                ? orderRes.message
                                : "Something went wrong, unable to get order details!"
                            );
                            return;
                          }
                          order = {
                            url: get(orderRes, "data.url", ""),
                            name: get(res.data, "name", ""),
                            email: "bidd_" + get(res.data, "email", ""),
                            phone: get(res.data, "phone", ""),
                            key: get(orderRes, "data.key_id", ""),
                            amount: get(orderRes, "data.amount", 0),
                            orderId: get(orderRes, "data.orderId", ""),
                            currency: get(orderRes, "data.currency", ""),
                            units: get(orderRes, "data.amountBreakup.units", 0),
                            userAmount: get(
                              orderRes,
                              "data.amountBreakup.userAmount",
                              0
                            ),
                          };
                          setOrder({ ...order });
                          // setLoader(false);
                          setOpenPaymentMode(true);
                          setUnits(get(orderRes, "data.amountBreakup.units", 0));
                          // goToRazorPay(order);
                        },
                        (err) => {
                          toast.error(
                            err.message
                              ? err.message
                              : "Something went wrong, unable to get order details!"
                          );
                        }
                      );
                    } else {
                      setSuccessModal(true);
                    }
                  }

                  if (paymentStatus) {
                    setPaymentSuccessMixpanel(true);
                    // setLoader(false);
                    setModalType("payment");
                    setStatusMessage(message);
                    setPaymentStatus(paymentStatus);
                    setSuccessModal(true);
                  }
                }
              }
            },
            (err) => {
              console.log("Third Party Data (Error):", err);
            }
          );
        });

      }
      if (queryParams && queryParams.productType !== "mld") {
        getCouponsAmount(productName);
      }
      setProductName(productName);
      if (queryParams.productType !== "ipo" && minUnit) {
        getUnitPrice(
          productName,
          { "X-product": `orobonds:${productName}` },
          units
        ).then(
          (result) => {
            const res = utils.parsePayload(result);
            if (!res.success) {
              return (
                setInputValueError(res.message)
              )
            }

            if (res.data) {
              setInputValueError('')
              if (res.data.futureCoupons) {
                setUnitPrice(res.data);
                setPriceResponse(res.data)
                let totalPay = res.data.futureCoupons.reduce((total, obj) =>
                  total + (obj.justCoupon ? obj.justCoupon : obj.CouponPer1k), 0)
                setTotalPayout(totalPay)
                let cleanUp = res.data.userAmount - res.data.accruedInterest;
                setCleanUpPrice(cleanUp)
                let clean_price = res.data.Price - res.data.accruedInterest;
                // setCleanPrice(clean_price);
              }
            }
          },
          (err) => {
            toast.error("Price Details (Error):", err);
          }
        );
      }
      if (queryParams.productType !== "unlisted") {
        fetchTransactions(productName);
        getPortfolio(
          productName,
          { "X-product": `orobonds:${productName}` }
        ).then((result) => {
          const response = utils.parsePayload(result);

          if (response && response.success) {
            if (response.data && response.data.pfStats) {
              setPfCoupon(response.data.pfStats);
              // setShowBanner(false);
              setPortfolioValue({ ...response });
            }
            if (response.data &&
              response.data.pfStats &&
              response.data.pfStats.pastCoupons &&
              response.data.pfStats.pastCoupons.length) {
              let pastCouponSum = 0.0;
              let pastCoupons = response?.data?.pfStats?.pastCoupons;

              pastCoupons.map((coupon) => {
                pastCouponSum += coupon?.justCouponPerMonth;
              })
              setRealisedCouponsSum(response.data.pfStats.couponPayout);
            }
            if (response.data &&
              response.data.pfStats &&
              response.data.pfStats.futureCoupons &&
              response.data.pfStats.futureCoupons.length) {
              let futureCouponSum = 0.0;
              let futureCoupons = response?.data?.pfStats?.futureCoupons
              futureCoupons.map((coupon) => {
                futureCouponSum = coupon?.CouponPerMonth;
              })
            }
          } else {
            toast.error("Error: Orobonds portfolio: Something went wrong");
          }
          // setLoader(false);
        });
      }
    }
  }, []);

  useEffect(() => {
    /* Mixpanel.track("p_asset_details",
      {
        "Bond Name": productName,
        "Email id": props.userEmail ? props.userEmail : ""
      }
    ); */
  }, [props.userEmail])

  useEffect(() => {
    if (priceResponse?.userAmount > assetDetails?.maxAmt) {
      setMaxAmt(true);
      //toast.error('Maximum total investment amount has to be less than ' + assetDetails?.maxAmt.oroNumber(2, true));
    } else {
      setMaxAmt(false);
    }
  }, [priceResponse, assetDetails])

  useEffect(() => {
    setLoader(true)
    let ISIN;
    if (queryParams.productType !== "unlisted" && productName) {
      getAllAssets({ "X-product": `orobonds:${productName}` }, { product: productName })
        .then(result => {
          const bonds = utils.parsePayload(result);
          if (!bonds || !bonds.success) {
            return toast.error("Error: Unable to fetch bonds details");
          }
          if (bonds && bonds.data && bonds.data.length) {
            let data = bonds?.data.find(e => e.bondId);
            ISIN = data.ISIN;
            setOppName(data?.issuer);
            setProductDetails({ ...data });
            getAssetDetails(ISIN, { "X-product": `orobonds:${productName}` }).then(
              (result) => {
                const res = utils.parsePayload(result);

                if (res) {
                  setLoader(false)
                  setAssetDetails(res.data);
                  setMinUnit(res.data.minUnits)
                  setUnits(res.data.minUnits)
                  setIsDisable(res.data.showOnBrowse)
                  setIsTxnAllowed(res.data.isTxnAllowed)
                  setOroloader(false)
                  if (res.data.rfqExchangeType) {
                    setExchange(String(res.data.rfqExchangeType).toLowerCase());
                  }
                }
              },
              (err) => {
                toast.error("Asset Details (Error):", err);
              }
            );
          };
        });
    }
  }, [minUnit])

  useEffect(() => {
    if (productName !== "" && queryParams.productType !== "ipo" && minUnit) {
      setProductName(productName);
      getUnitPrice(
        productName,
        { "X-product": `orobonds:${productName}` },
        units
      ).then(
        (result) => {
          const res = utils.parsePayload(result);
          if (!res.success) {
            return setInputValueError(res.message);
          }

          if (res.data) {
            setInputValueError('')
            if (res.data.futureCoupons) {
              setUnitPrice(res.data);
              setPriceResponse(res.data)
              let totalPay = res.data.futureCoupons.reduce((total, obj) =>
                total + (obj.justCoupon ? obj.justCoupon : obj.CouponPer1k), 0)
              setTotalPayout(totalPay)
              let cleanUp = res.data.userAmount - res.data.accruedInterest;
              setCleanUpPrice(cleanUp)
              let clean_price = res.data.Price - res.data.accruedInterest;
              // setCleanPrice(clean_price);
            }
          }
        },
        (err) => {
          toast.error("Price Details (Error):", err);
        }
      );

    }
  }, [units, assetDetails])

  const getCouponsAmount = (productName) => {
    getInterstAmount(
      productName,
      { "X-product": `orobonds:${productName}` }
    ).then(
      (result) => {
        const res = utils.parsePayload(result);
        if (
          res &&
          res.data &&
          res.data.futureCoupons &&
          res.data.futureCoupons.length
        ) {
          setCouponsPer1k(res.data.futureCoupons);
          let coupons = res.data.futureCoupons;
          let couponsAmount = 0.0;
          let preTaxAmount = 0.0;
          for (var i = 0; i < coupons.length; i++) {
            couponsAmount += coupons[i]?.CouponPer1k;
          }
          preTaxAmount = couponsAmount * units;
          // setFinalAmount(preTaxAmount);
          setCoupons(res.data);
        }
      },
      (err) => {
        toast.error("Interest Amount (Error):", err);
      }
    );
  };

  const increaseUnits = () => {
    setUnits(((units) => (Number(units) + assetDetails.stepSize)));
  };

  const decreaseUnits = () => {
    if (units > minUnit) {
      setUnits(((units) => (Number(units) - assetDetails.stepSize)));
    }
  };

  const startInvestingFlow = () => {
    if (!isKycDone) {
      redirectToDocs();
    } else {
      updateInvestmentAmount();
    }
  };

  const goToPaymentOverview = async () => {
    setShowConsent(true);
  };

  const updateInvestmentAmount = async () => {
    let res = await getInvestmentAmount(
      units * get(unitPrice, "Price", 0),
      units,
      product,
      { "X-product": `orobonds:${product}` }
    ).then(response => {
      return utils.parsePayload(response); 
    });
    if (res && !res.success) {
      toast.error(
        res.message
          ? res.message
          : "Something went wrong, unable to create the Digio e-sign document!"
      );
      return;
    }

    if (res && res.success) {
      setInvestmentAmount(res.data);
      togglePaymentModal();
    }
  };

  useEffect(() => {
    let order;
    if (queryParams.productType === "unlisted") {
      if (queryParams && queryParams.product) {
        let isinUnlisted = queryParams.product.split("?")[0]
        const qp = new URLSearchParams(
          queryParams.product.split('?')[1]
        );
        const orderId = qp.get("orderId");
        // setIsinUnlisted(isinUnlisted)
        getThirdPartyData({ "X-product": `orobonds:${productName}`, 'x-encrypted-data': true }).then(
          (result) => {
            const res = utils.parsePayload(result);
            setIsTpdLoaded(true);
            // if (res && res.success) {
            //   getUnlistedOrderDetails(isinUnlisted, orderId, { "X-product": `orobonds:${productName}` }).then(
            //     (orderRes) => {
            //       if (orderRes && !orderRes.success) {
            //         toast.error(
            //           orderRes.message
            //             ? orderRes.message
            //             : "Something went wrong, unable to get order details!"
            //         );
            //         return;
            //       } else if (orderRes && orderRes.success && orderRes.data.length) {
            //         setOpenPaymentMode(true);
            //         order = {
            //           "url": orderRes?.data[0]?.pgDetails.callback,
            //           "name": orderRes?.data[0].name,
            //           "email": orderRes?.data[0]?.email,
            //           "phone": res.data.phone,
            //           "key": orderRes?.data[0]?.key_id,
            //           "amount": orderRes?.data[0]?.amount,
            //           "orderId": orderRes?.data[0]?.orderId,
            //           "currency": orderRes?.data[0]?.rzpOrderDetails.currency,
            //           "units": orderRes?.data[0]?.units,
            //           "userAmount": orderRes?.data[0]?.userAmount
            //         };
            //         setOrder({ ...order });
            //       }
            //     }
            //   )
            // }
          }
        )
      }
    }
  }, [])

  const togglePaymentModal = () => {
    setPaymentModalOpen(!paymentModalOpen);
  };

  const redirectToDocs = () => {
    history.push({
      pathname: "/biddeasy-docvault/",
    });
  };

  useEffect(() => {
    // debugger;
    try {
      if (cashfree == null && cashfreeSessionId) {
        cashfreeInitiate();
      } else if (cashfree && Object.entries(cashfree).length > 0 && cashfreeSessionId) {
        cashfreeDoPayment();
      }
    } catch (ex) {
      // debugger;
      console.log("useEffect cashfree");
      toast.error("PG Cashfree (Error): ", ex);
    }
  }, [cashfree, cashfreeSessionId])

  /* useEffect(() => {
    console.log("cashfree: ", cashfree, cashfreeSessionId);
  }) */

  const cashfreeInitiate = () => {
    // debugger;
    // if (!Object.entries(cashfree?.cashfree).length) {
      // debugger;
      const cashfreeInitializeSDK = async function () {
        const _cashfree = await load({
          mode: process.env.REACT_APP_CF_MODE
        });
        // setCashfree(Object.asssign(cashfree, { cashfree: _cashfree }));
        // const obj = _.merge(cashfree, { cashfree: _cashfree });
        setCashfree(_cashfree);
      }
      cashfreeInitializeSDK();
    // }
  }

  const fnSendToExchange = (url, header, params) => {
    // debugger;
    // console.log("isRetry", retryCountAtExchange, { ...params, orderId: cashfreeOrderId });
    if (retryCountAtExchange <= 2) {
      setRetryCountAtExchange((prevRetryCountAtExchange) => ++prevRetryCountAtExchange);
      sendToExchange(url ?? "/orobonds/pg/sendToExchange", 
        { ...header, "X-product": `orobonds:${product}` },
        utils.getPKey()
          ? { payload: utils.encryptedPayload({ ...params, orderId: cashfreeOrderId }) }
          : { ...params, orderId: cashfreeOrderId })
        .then(result => {
          const res = utils.parsePayload(result);
          if (res && res.success == true && res.data) {
            if (res.data.rfqOrderDetails.orderNumber) {
              setCashfreePaymentStatusPopupData({
                ...orderStatuses.success,
                message: `
                  <span><b>Your order has been processed<br/>successfully</b></span>
                  <span>The securities will be settled in your account on ${res.data.rfqOrderDetails.settlementDate}</span>
                `
              });
              return;
            } else {
              setCashfreePaymentStatusPopupData({
                ...orderStatuses.failedAndRetry
              });
            }
          } else if (res && res.success == false) {
            if (res.message?.replace(/\W/gim, "").indexOf("Cannot place order in non Market hrs".replace(/\W/gi, "")) > 0) {
              setCashfreePaymentStatusPopupData({
                ...orderStatuses.successButOnHold
              });
              return;
            } else {
              setCashfreePaymentStatusPopupData({
                ...orderStatuses.failedAndRetry
              });
            }
          }
        });
    } else {
      // setCashfreePaymentStatusPopup
      setRetryCountAtExchange(0);
      /* setCashfreePaymentStatusPopupData({
        status: "failed",
        sendToExchange: false,
        title: "Order Failed",
        message: `
        <span>Your order could not be processed
        <br/>Kindly check later</span>
      `,
        spinner: false,
        orderId: cashfreeOrderId,
        note: "",
        showCloseBtn: true,
        retry: false
      }); */

      setCashfreePaymentStatusPopupData({
        ...orderStatuses.failedAndRetry,
        ...{
          message: `
            <span>Your order could not be processed
            <br/>Kindly check later</span>
          `,
          showCloseBtn: true,
        }
      });
    }
  }

  const cashfreeDoPayment = async () => {
    // debugger;
    setPaymentLinkLoader(false);
    canclePaymentModelRfq();

    const doPayment = async () => {
      let checkoutOptions = {
        paymentSessionId: cashfreeSessionId,
        redirectTarget: "_modal",
      };
      // debugger;
      cashfree.checkout(checkoutOptions).then((result) => {
        // debugger;
        if (result.error) {
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log(
            "User has closed the popup or there is some payment error",
            "\n", result.error
          );
          
          /** clean search params in case of CF closed 
           * If from partner link & in case of payment session id expired
           * CF sends error even if payment succeeded.
          */
          const redirectWithCleanParams = isAdvisory ? window.location.href.split('?')[0] : null;

          setCashfreePaymentStatusPopupData({
            ...paymentStatuses.failed,
            ...{ redirectWithCleanParams },
            ...{ reloadPage: isAdvisory ? false : true }
          });
          setCashfreePaymentStatusPopup(true);
        } 

        /* if (result.redirect) {
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("User will be redirected");

          setCashfreePaymentStatusPopupData({
            ...paymentStatuses.failed
          });
          setCashfreePaymentStatusPopup(true);
        }  */
        
        if (result.paymentDetails) {
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log(
            "Payment has been completed, Check for Payment Status",
            "\n", result.paymentDetails.paymentMessage
          );

          setCashfreePaymentStatusPopupData({
            ...paymentStatuses.success
          });
          setCashfreePaymentStatusPopup(true);

          cashfreeCheckPaymentStatus("/orobonds/pg/checkPaymentStatus",
            { "X-product": `orobonds:${product}` },
            utils.getPKey()
              ? { payload: utils.encryptedPayload({ orderId: cashfreeOrderId }) }
              : { orderId: cashfreeOrderId })
            .then((result) => {
              const response = utils.parsePayload(result);
              if (response && response.data) {
                if (isAdvisory) {
                  // setSubPartnerId(response.data.subPartner);
                  setSubPartnerRedirectUrl(utils.subPartnerRedirectTo(response.data.subPartner));
                  // setSubPartnerRedirectUrl(response.data.subPartner);
                }

                switch (response.data.paymentStatus?.toLowerCase()) {
                  case "success":
                    fnSendToExchange(null, {}, {});
                    break;
                  case "pending":
                    if (response.data.paymentType == "bank_transfer") {
                      setCashfreePaymentStatusPopupData({
                        ...paymentStatuses.pending,
                        title: 'Order Placed',
                        message: `
                          <span>Kindly complete the payment through NEFT/RTGS as per the Challan details in the next 2 working days.</span>
                        `
                      })
                    } else {
                      setCashfreePaymentStatusPopupData({
                        ...paymentStatuses.pending
                      });
                    }
                    setCashfreePaymentStatusPopup(true);
                    break;
                  case "failed":
                    setCashfreePaymentStatusPopupData({
                      ...paymentStatuses.failed
                    });
                    setCashfreePaymentStatusPopup(true);
                    break;
                  default:
                    setCashfreePaymentStatusPopupData({
                      ...paymentStatuses.failed
                    });
                }
              }
            }, (err) => {
              toast.error("Cashfree CheckPaymentStatus (Error): ", err);
            });
        }
      });
    };
    doPayment();
  }

  const togglePriceDifferencePopUp = (param) => {
    if (param == 'cancel') {
      window.location.reload();
      return;
    }
    setOpenPaymentMode(false);
    setPriceChangePopup(prev => !prev);
  }

  const togglePaymentMode = async () => {
    // debugger;
    var res;
    let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
    const payload = {
      orderId: order.orderId,
    };
    const header = {
      "X-product": `orobonds:${product}`
    }
    { process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("SI" + product + "PaymentSelected");
    }
    /* Mixpanel.track("cl_pay",
      {
        "Pay Type": paymentMethod,
        "Bond Name": productDetails.issuer,
        "Email id": props.userEmail
      }
    ); */
    // if (window.ReactNativeWebView && paymentMethod === "netbanking") {
    //   let currentUrl = window.location.href;

    //   let token = localStorage.getItem("token");
    //   console.log("#token", token);
    //   if (token && currentUrl) {
    //     let tempRedirectionUrl = process.env.REACT_APP_API_BIDD_URL + '/partner/validate/user?token=' + token + '&redir=' + currentUrl;
    //     return window.ReactNativeWebView.postMessage(
    //       JSON.stringify({ 
    //         action: "BIDD_RZP_RED_URL", 
    //         data: {
    //           redirectionUrl: tempRedirectionUrl,
    //         }
    //       })
    //     )
    //   }
    // }
    // debugger;
    if ((paymentMethod === "upi" || paymentMethod === "netbanking") && !assetDetails.userInRfqCug) {
      /* if (exchange === "nse") {
        // check conditons here
      } else { */
        // goToRazorPay(order);
      /* } */
    } else if ((paymentMethod === "upi" || paymentMethod === "netbanking" || (paymentMethod === "neft" && exchange === "nse")) && !paymentTried && assetDetails.userInRfqCug) {
      setPaymentLinkLoader(true)
      try {
        const purchaseOrderParams = {
          demat: get(thirdPartyData, "demat", ""),
          units: get(investmentAmount, "units", ""),
          custId: get(userProfile, "custId", ""),
          pan: dematPan,
          paymentType: paymentMethod,
          exchange: exchange,
        };

        const res = await createPurchaseOrder(purchaseOrderParams, product, { "X-product": `orobonds:${product}` }, productDetails.ISIN).then(result => {
          return utils.parsePayload(result);
        });

        if (res.success) {
          // setPgPurchaseCalled(true);
          setPgPurchaseResponse(res);
          setTmpOrderId(res.data.orderId);
          if (exchange === "nse" && res.data.pgPartner === "cashfree") {
            // debugger;
            // const obj = Object.asssign(cashfree, ({ sessionId: res.data.paymentDetails.sessionId }));
            // const obj = _.merge(cashfree, ({ sessionId: res.data.paymentDetails.sessionId }));
            setCashfreeOrderId(res.data.orderId);
            setCashfreeSessionId(res.data.paymentDetails.sessionId);
            // cashfreeInitiate();
          } else {
            let payloadPayment = {
              rfqOrderNo: res.data.rfqOrderDetails.rfqOrderNo,
              OrderNo:res.data.rfqOrderDetails.orderNumber,
              orderId : res.data.orderId,
              paymentType: paymentMethod,
            }
            getPaymentLink(payloadPayment, header).then((response) => {
              if (response) {
                if (!response.success) {
                  setPaymentTried(true)
                } else if (response.success) {
                  setPaymentLinkLoader(false)
                  if (response.data.paymentLink && response.data.paymentLink.length) {
                    let payloadUpdate = {
                      orderId: res.data.orderId,
                      updatedOrder: {
                        paymentType: paymentMethod,
                      }
                    }
                    purchaseNeftPaymentLink(payloadUpdate, header).then((res) => {
                      if (res) {
                        if (!res.success) {
                          toast.error(
                            res.message || "Error: orobonds purchase: Something went wrong"
                          );
                          setPaymentStatus("failure");
                          setStatusMessage("Payment Failed");
                        } else if (res.success) {
                          const successMessage = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
                          setPaymentStatus("success");
                          setStatusMessage(successMessage);
                          setModalType("payment");
                          setOpenNeftRtgs(false);
                          setIsOngoingOrder(false);
                          setSuccessModal(true);
                          setOpenPaymentMode(!openPaymentMode);
                          setPaymentLinkRes(response.data.paymentLink)
                          window.open(response.data.paymentLink, "_blank");
                        }
                      }
                    })
                  }
                } else {
                  setPaymentLinkLoader(false)
                  setPaymentTried(true)
                }
              }
            })
          }
        } else if (!res.success) {
          if (exchange === "nse" && res.data?.pgPartner === "cashfree") {
            toast.error(String(res.message));
            // togglePaymentModal();
            setOpenPaymentMode(false);
            setPaymentStatus("failure");
            setStatusMessage("Payment Failed");
            setPopUpFailedBse(true); // show default failed popup (BSE)
            // setCashfreePaymentStatusPopupData({
            //   ...paymentStatuses.failed
            // });
            // setCashfreePaymentStatusPopup(true);
          } else {
            toast.error(String(res.message),
              {
                onClose: () => window.location.reload(),
              }
            );
            setOpenPaymentMode(false);
            setPaymentStatus("failure");
            setStatusMessage("Payment Failed");
            // toggleFailedBse();
          }
        } else {
          setPaymentTried(true)
          // let bannerText = "Payment Link Generation Failed. There seems to be some technical issue. Please retry payment";
          // setBannerTextForReferred(bannerText)
          // setPaymentStatus("failure");
          // setStatusMessage("Payment Failed");
          // toggleFailedBse()
        }
      } catch (createOrderError) {
        console.error("Error in createPurchaseOrder:", createOrderError);
        setOpenPaymentMode(false)
        let bannerText = "Payment Link Generation Failed. There seems to be some technical issue. Please retry payment";
          setBannerTextForReferred(bannerText)
          setPaymentStatus("failure");
          setStatusMessage("Payment Failed");
          toggleFailedBse()
        // setPaymentTried(true)
      }
    } else {
        setOpenPaymentMode(!openPaymentMode);
        const updatePayload = {
          orderId: order.orderId ? order.orderId : tmpOrderId ? tmpOrderId : ""
        };
        purchaseNeft(updatePayload, header).then((response) => {
          if (response) {
            if (!response.success) {
              toast.error(
                response.message || "Error: orobonds purchase: Something went wrong"
              );
              setPaymentStatus("failure");
              setStatusMessage("Payment Failed");
            } else {
              setPaymentStatus("success");
              setStatusMessage(successed);
              { process.env.REACT_APP_RENDER_GA === "true" &&
                setAnalyticsEvent("Investment_Done");
              }
              setOpenPaymentMode(!openPaymentMode);
            }
          }
        })
        setOpenNeftRtgs(true);
    }
  };

  const gobackPaymentMode = () => {
    setOpenPaymentMode(false);
    setPaymentModalOpen(true);
  };

  const toggleNeftRtgs = () => {
    setOpenNeftRtgs(!openNeftRtgs);
    setOpenPaymentMode(true);
  };

  /* const toggleInstruction = () => {
    setOpenInstruction(false);
    setOpenPaymentMode(true);
  }; */

  const showInstruction = () => {
    // setOpenInstruction(true);
    setOpenNeftRtgs(false);
  };


  const neftPaymentSuccess = async () => {
    var res;
    setLoaderForNEFT(true);
    if (!ucc?.bse?.uccCreated || !assetDetails.userInRfqCug) {
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("Investment_Done");
      }
      const payload = {
        orderId: order.orderId,
      };

      let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
      /* Mixpanel.track("p_order_placed_success_neft",
        {
          "Pay Type": paymentMethod,
          "Bond Name": productDetails.issuer,
          "Email id": props.userEmail
        }
      ); */
      setPaymentStatus("success");
      setStatusMessage(successed);
      setModalType("payment");
      setUnits(1);
      setOpenNeftRtgs(false);
      setIsOngoingOrder(false);
      setSuccessModal(true);
      getObUserState(
        {
          email: get(userProfile, "email", ""),
          pan: get(userProfile, "pan", ""),
        },
        product,
        { "X-product": `orobonds:${product}` }
      ).then(
        (result) => {
          const res = utils.parsePayload(result);
          if (res && res.success) {
            setUserState({ ...res.results });
          }
        },
        (err) => {
          toast.error("Something went wrong, unable to get kyc details!");
        }
      );
    } else if (ucc?.bse?.uccCreated || ucc?.nse?.uccCreated) {
      if (ucc?.bse?.uccCreated && assetDetails.userInRfqCug) {
        try {
          if (!paymentTried) {
            res = await createPurchaseOrder(
              {
                demat: get(thirdPartyData, "demat", ""),
                units: get(investmentAmount, "units", ""),
                custId: get(userProfile, "custId", ""),
                pan: dematPan,
                exchange: "bse",
                paymentType: "NEFT",
              },
              product,
              { "X-product": `orobonds:${product}` },
              productDetails.ISIN
            ).then(result => {
              return utils.parsePayload(result);
            });
            let payloadPayment = {
              rfqOrderNo: res.data.rfqOrderDetails.rfqOrderNo,
              OrderNo: res.data.rfqOrderDetails.orderNumber,
              orderId : res.data.orderId,
              paymentType: "NEFT",
              forced: true,
            }
            const header = {
              "X-product": `orobonds:${product}`
            }
            setPaymentLinkLoader(true)
            getPaymentLink(payloadPayment, header).then((response) => {
              if (response) {
                if (!response.success) {
                  setPaymentTried(true)
                } else if (response.success) {
                  setPaymentLinkLoader(false)
                } else {
                  return
                }
              }
            })
            setLoaderForNEFT(false);
          } else {
            let payloadPayment = {
              rfqOrderNo: res.data.rfqOrderDetails.rfqOrderNo,
              OrderNo: res.data.rfqOrderDetails.orderNumber,
              orderId : res.data.orderId,
              paymentType: "NEFT",
              forced: true,
            }
            const header = {
              "X-product": `orobonds:${product}`
            }
            setPaymentLinkLoader(true)
            getPaymentLink(payloadPayment, header).then((response) => {
              const payload = {
                orderId: order.orderId,
              };
              if (response) {
                if (!response.success) {
                  setPaymentTried(true)
                } else if (response.success) {
                  setPaymentLinkLoader(false)
                  purchaseNeft(payload, header).then((response) => {
                    if (response) {
                      if (!response.success) {
                        toast.error(
                          response.message || "Error: orobonds purchase: Something went wrong"
                        );
                        setPaymentStatus("failure");
                        setStatusMessage("Payment Failed");
                      }
                      setLoaderForNEFT(false);
                    }
                  })
                } else {
                  setOpenNeftRtgs(!openNeftRtgs)
                  let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
                  setPaymentStatus("success");
                  setStatusMessage(successed);
                  setModalType("payment");
                  setUnits(1);
                  setOpenNeftRtgs(false);
                  setIsOngoingOrder(false);
                  setSuccessModal(true);
                }
              }
            })
          }
        } catch (createOrderError) {
          console.error("Error in createPurchaseOrder:", createOrderError);
        }
      } else if (ucc?.nse?.uccCreated && assetDetails.userInRfqCug) {
        try {
          res = await createPurchaseOrder(
            {
              demat: get(thirdPartyData, "demat", ""),
              units: get(investmentAmount, "units", ""),
              custId: get(userProfile, "custId", ""),
              pan: dematPan,
              exchange: "nse",
              paymentType: "NEFT",
            },
            product,
            { "X-product": `orobonds:${product}` },
            productDetails.ISIN
          ).then(result => {
            return utils.parsePayload(result);
          });
          setLoaderForNEFT(false);
          window.open(res.data.rfqOrderDetails.paymentLink, "_blank");
        } catch (createOrderError) {
          console.error("Error in createPurchaseOrder:", createOrderError);
        }
      }
      if (res && res.success) {
        const payload = {
          orderId: res.data.orderId,
        };
        const header = {
          "X-product": `orobonds:${product}`
        }
        purchaseNeft(payload, header).then((response) => {
          if (response) {
            if (!response.success) {
              toast.error(
                response.message || "Error: orobonds purchase: Something went wrong"
              );
              setPaymentStatus("failure");
              setStatusMessage("Payment Failed");
            }
            setLoaderForNEFT(false);
          }
        })
        let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
        setPaymentStatus("success");
        setStatusMessage(successed);
        setModalType("payment");
        setUnits(1);
        setOpenNeftRtgs(false);
        setIsOngoingOrder(false);
        setSuccessModal(true);
      } else if (res && !res.success) {
        toggleFailedBse()
        setOpenNeftRtgs(!openNeftRtgs)
      } else {
        const header = {
          "X-product": `orobonds:${product}`
        }
        let payloadPayment = {
          rfqOrderNo: pgPurchaseResponse.data.rfqOrderDetails.rfqOrderNo,
          OrderNo: pgPurchaseResponse.data.rfqOrderDetails.orderNumber,
          orderId : pgPurchaseResponse.data.orderId,
          paymentType: "NEFT",
          forced: true,
        }
        getPaymentLink(payloadPayment, header).then((response) => {
          const payload = {
            orderId: pgPurchaseResponse.data.orderId,
          };
          if (response) {
            if (!response.success) {
              setPaymentTried(true)
            } else if (response.success) {
              purchaseNeft(payload, header).then((response) => {
                if (response) {
                  if (!response.success) {
                    toast.error(
                      response.message || "Error: orobonds purchase: Something went wrong"
                    );
                    setPaymentStatus("failure");
                    setStatusMessage("Payment Failed");
                  }
                  setLoaderForNEFT(false);
                }
                setOpenNeftRtgs(!openNeftRtgs)
                let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
                setPaymentStatus("success");
                setStatusMessage(successed);
                setModalType("payment");
                setUnits(1);
                setOpenNeftRtgs(false);
                setIsOngoingOrder(false);
                setSuccessModal(true);
              })
            } else {
              setOpenNeftRtgs(!openNeftRtgs)
              let successed = 'Thank you! <br/> Your order has been placed successfully! <br/> Units will be credited to your Demat account subject to the realization of payment';
              setPaymentStatus("success");
              setStatusMessage(successed);
              setModalType("payment");
              setUnits(1);
              setOpenNeftRtgs(false);
              setIsOngoingOrder(false);
              setSuccessModal(true);
            }
          }
        })
      }
    }
  };



  useEffect(() => {
    if (
      location.state &&
      location.state.from &&
      location.state.from === "dematCheck" &&
      location.state.isDematVerified
    ) {
      updateInvestmentAmount();
    }
  }, [location]);


  useEffect(() => {
    getCouponSum();
  },[couponsPer1k]);

  /* const setHyperVergeScript = (src) => {
    if (typeof window !== "undefined") {
      // if (typeof window.Hyperverge === "undefined") {
      if (!document.getElementById("idHyperVerge")) {
        const script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("id", "idHyperVerge");
        script.setAttribute("src", String(process.env.REACT_APP_HYPERVERGE_SCRIPT));
        document.getElementsByTagName("body")[0].appendChild(script);
        script.addEventListener("load", () => {
          console.log("HV script loaded");
          // setHasDigioSDK(true);
        });
      } 
      // else {
      //   setHasDigioSDK(true);
      // }
    }
  }; */

  useEffect(() => {
    // setHyperVergeScript();
    const searchParms = new URL(window.location.href);
    
    if (searchParms['hash'] && searchParms['hash'].includes('partner=icmAdvisory')) {
      setIsAdvisory(true);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (order?.userAmount > 100000) {
      setpaymentMethod('netbanking');
    }
  }, [order.userAmount])

  useEffect(() => {
    if (ucc?.bse?.uccCreated) {
      setpaymentMethod('neft');
    }
  }, [ucc])

  useEffect(() => {
    if (paymentMethod && productDetails.issuer && props.userEmail) {
      /* Mixpanel.track("p_payment_success",
        {
          "Pay Type": paymentMethod,
          "Bond Name": productDetails.issuer,
          "Email id": props.userEmail
        }
      ); */
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(window.location.pathname + window.location.hash,
          "Investment_Done"
        );
      }
      // facebook pixel integration
      // ReactPixel.track('PURCHASED');
    }
  }, [paymentSuccessMixpanel]);

  const startInvest = () => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour12: false,
    });
    let enhancedKYCStatuses = ["pending", "retry"];
    let enhancedStatus = thirdPartyData.enhancedKycStaus;

    if (isKycDone && thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC) {
      if (enhancedKYCStatuses.includes(enhancedStatus)) {
        toggleHvInitiateModal();
      }
      // if (!allowTxnByCVL) {
      //   return toggleHvInitiateModal();
      // }
    } /* else if (isKycDone && thirdPartyData.userInHypervergeCug && !thirdPartyData.forceKYC) {
      return goToPaymentOverview();
     } */ else if (!isKycDone && thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC) {
      setAnalyticsEvent("Bidd_Assest_Page_Get_Started", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_Get_Started`, product);
                }).catch(error => console.error('Error initializing Branch:', error));
    
      sendGTMEvent("Bidd_Assest_Page_Get_Started_GTM", {email: thirdPartyData?.email || ""});
      ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ 
            action: "BIDD_HV", 
            data: {
              assetCode: assetDetails?.product,
              productType: assetDetails?.productType
            }
          })
        )
      } else {
        return hypervergeVerification();
      }
    }
    if (isNewJourney || errors.length) {
      let payload = {
        "event": "track",
        "action": "obPreKycInvestNow",
        "data": {
          "email": props.userEmail,
          "product": product
        }
      };
      obPreKycInvestNow(payload, { "X-product": `orobonds:${product}` })
        .then(res => {
          if (res && res.success) {
            { process.env.REACT_APP_RENDER_GA === "true" &&
              setAnalyticsEvent("Bonds_GetStarted_Click");
              setAnalyticsEvent("Bidd_Assest_Page_Get_Started", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_Get_Started`, product);
                }).catch(error => console.error('Error initializing Branch:', error));
            }
            sendGTMEvent("Bidd_Assest_Page_Get_Started_GTM", {email: thirdPartyData?.email || ""});
            ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
            // ReactPixel.track('GET STARTED ASSET PAGE');
            // history.push({
            //   pathname: '/biddeasy-docvault'
            // });
             if(!thirdPartyData.userInHypervergeCug) {
              setAnalyticsEvent("Bidd_Assest_Page_Get_Started", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_Get_Started`, product);
                }).catch(error => console.error('Error initializing Branch:', error));
              ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
              window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
            }
          }
        })
    } /* else if (isKycDone && thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC) {
      toggleHvInitiateModal();
    } */ else if (isKycDone && !thirdPartyData.userInHypervergeCug) {
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("Investment_Initiated");
      }
      /* Mixpanel.track("cl_invest_now",
        {
          "Bond Name": productDetails.issuer,
          "Email id": props.userEmail
        }
      ); */
         
      // facebook pixel integration
      // ReactPixel.track('Bonds_Investment_Initiated');

      if (!isUccNse.created) {
        setIsUccNse({ ...isUccNse, popup: true });
        return;
      }
      initBranch()
        .then(() => trackEvent(`Bidd_Assest_Page_Invest_Now_${productDetails.product}`,
          thirdPartyData?.email || "",
          thirdPartyData?.phone || "",
          thirdPartyData?.userId || "",))
        .catch((error) => console.error("Error initializing Branch:", error));

      setTransactionStartTime(currentTime);
      goToPaymentOverview();
    } 
    else if (isKycDone && !thirdPartyData.forceKYC && thirdPartyData.enhancedKycStaus === "approved") {
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("Investment_Initiated");
      }
      /* Mixpanel.track("cl_invest_now",
        {
          "Bond Name": productDetails.issuer,
          "Email id": props.userEmail
        }
      ); */

      // facebook pixel integration
      // ReactPixel.track('Bonds_Investment_Initiated');

      if (!isUccNse.created) {
        setIsUccNse({ ...isUccNse, popup: true });
        return;
      }
      initBranch()
        .then(() => trackEvent(`Bidd_Assest_Page_Invest_Now_${productDetails.product}`,
          thirdPartyData?.email || "",
          thirdPartyData?.phone || "",
          thirdPartyData?.userId || "",))
        .catch((error) => console.error("Error initializing Branch:", error));
      setTransactionStartTime(currentTime);
      goToPaymentOverview();
    }
  };

  const redirectToPartner = (fromExchange, status, orderId) => {
    if (fromExchange) {
      if (status === "success") {
        window.location.replace(`${subPartnerRedirectUrl}/orders/${orderId}/payments/status/?status=success`);
        return;
      } else {
        window.location.replace(`${subPartnerRedirectUrl}/orders/${orderId}/payments/status/?status=failure`);
        return;
      }
    } else {
      window.location.href = `${subPartnerRedirectUrl}/orders/${orderId}/payments/status/?status=failure`;
    }
  }
  
  const getUserStateBannerHvUser = () => {
    let enhancedStatus = thirdPartyData?.enhancedKycStaus;
    let enhancedKYCStatuses = ["approved", "pending", "retry"];
    if (enhancedStatus === "underProcess") {
      return (
        <StateCardBasic
          state="pending"
          cta="Complete your KYC"
          text1={"Thank you for sharing your KYC details, Your details will be verified within 24 - 48 working hours."}
          text2=""
          isMobile={isMobile}
          profile={true}
          // hypervergeVerification={cvlValidate && enhancedKYCStatuses.includes(enhancedStatus) ? hypervergeVerification : null}
        />
      );
    }
    if (enhancedStatus === "approved") {
      return (
        <StateCardBasic
          img={done}
          state="done"
          cta="Invest now"
          userState={userState}
          onClick={() => {
            scrollToSection(investSectionRef);
          }}
          text1="Congratulations! Your KYC is verified."
          text2="Click here to start Investing."
          product={product}
          isMobile={isMobile}
        />
      );
    } 
    if ((enhancedStatus === "pending")) {
      return (
        <StateCardBasic
          state="pending"
          cta="Complete your KYC"
          onClick={() => {
            setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                }).catch(error => console.error('Error initializing Branch:', error))
            ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
            if (thirdPartyData.forceKYC && thirdPartyData.userInHypervergeCug && thirdPartyData?.enhancedKycStaus === "pending" || thirdPartyData?.enhancedKycStaus === "retry") {
               if (isKycDone && thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC && (cvlValidate && enhancedKYCStatuses.includes(enhancedStatus))) {
                 return toggleHvInitiateModal();
              }else if(thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC){
                if (window.ReactNativeWebView) {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({ 
                      action: "BIDD_HV", 
                      data: {
                        assetCode: assetDetails?.product,
                        productType: assetDetails?.productType
                      }
                    })
                  )
                } else {
                  return hypervergeVerification();
                }
              }
            } else if (!thirdPartyData.userInHypervergeCug) {
              window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
            }
          }}
          text1={"Start your investment by completing your KYC, it takes few mintues."}
          text2="Start Now."
          isMobile={isMobile}
          profile={true}
        // hypervergeVerification={hypervergeVerification}
        />
      )
    } 
    if ((enhancedStatus === "rejected")) {
      return (
        <StateCardBasic
          state="failed"
          cta="Complete your KYC"
          onClick={() => {
            setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                }).catch(error => console.error('Error initializing Branch:', error))
              ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
            if ((thirdPartyData?.enhancedKycStaus === "rejected")) {
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({ 
                    action: "BIDD_HV", 
                    data: {
                      assetCode: assetDetails?.product,
                      productType: assetDetails?.productType
                    }
                  })
                )
              } else {
                return hypervergeVerification();
              }
            } else if (!thirdPartyData.userInHypervergeCug) {
              window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
            }
          }}
          text1={"Oops!! Your KYC is rejected, complete it to be investment ready."}
          text2="Re-initiate KYC."
          isMobile={isMobile}
          profile={true}
        // hypervergeVerification={hypervergeVerification}
        />
      )
    }
    if ((enhancedStatus === "retry")) {
      return (
        <StateCardBasic
          state="failed"
          cta="Complete your KYC"
          onClick={() => {
            setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                }).catch(error => console.error('Error initializing Branch:', error))
              ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
            if ((thirdPartyData?.enhancedKycStaus === "retry")) {
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({ 
                    action: "BIDD_HV", 
                    data: {
                      assetCode: assetDetails?.product,
                      productType: assetDetails?.productType
                    }
                  })
                )
              } else {
                return hypervergeVerification();
              }
            } else if (!thirdPartyData.userInHypervergeCug) {
              window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
            }
          }}
          text1={"Oops!! It seems that you have not completed your KYC,complete it to be investment ready."}
          text2="Re-initiate KYC."
          isMobile={isMobile}
          profile={true}
        // hypervergeVerification={hypervergeVerification}
        />
      )
    }
  }

  const getUserStateBanner = () => {
    if (assetDetails && assetDetails.category !== 'historical' && productType !== "ipo") {
      if (isNewJourney) {
        return (
          <StateCardBasic
            img={pending}
            state="pending"
            cta="Complete your KYC"
            userState={userState}
            onClick={() => {
              setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                }).catch(error => console.error('Error initializing Branch:', error))
                ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
              if (thirdPartyData.forceKYC && thirdPartyData.userInHypervergeCug && thirdPartyData?.enhancedKycStaus === "pending" || thirdPartyData?.enhancedKycStaus === "retry" || thirdPartyData?.enhancedKycStaus === "rejected") {
                hypervergeVerification()
              } else if (thirdPartyData.userInHypervergeCug && (thirdPartyData?.enhancedKycStaus === "underProcess" || thirdPartyData?.enhancedKycStaus === "approved")) {
                return
              } else if(!thirdPartyData.userInHypervergeCug) {
                window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
              }
            }}
            text1={bannerTextForReferred}
            text2={(thirdPartyData.userInHypervergeCug && thirdPartyData?.enhancedKycStaus === "underProcess" || thirdPartyData?.enhancedKycStaus === "approved") ? "" : "Click here to start now."}
            product={product}
            isMobile={isMobile}
          // hypervergeVerification={hypervergeVerification}
          />
        );
      }
      if (Object.keys(userState).length) {
        if (userState.obUserApproved) {
          if (userState.obOrderAttempted && !userState.obPaymentDone && !assetDetails.userInRfqCug) {
            return (
              isAdvisory ?
                redirectToPartner()
              :
              <StateCardBasic
                img={failed}
                state="failed"
                cta="Try again"
                userState={userState}
                onClick={() => {
                  scrollToSection(investSectionRef);
                }}
                text1={assetDetails.userInRfqCug ? "Payment Link Generation Failed." : "Sorry, your order is not placed."}
                text2={assetDetails.userInRfqCug ? "There seems to be some technical issue. Please retry payment" : "Click here to place a new order."}
                product={product}
                isMobile={isMobile}
              />
            );
          }
          if (
            userState.obPaymentDone &&
            !userState.obOrderApproved &&
            !userState.obOrderRejected
          ) {
            return (
              <>
                {!openPaymentMode && !succesModal &&
                  <StateCardBasic
                    img={done}
                    state="pending"
                    cta="Invest now"
                    userState={userState}
                    onClick={() => {
                      scrollToSection(txnRef);
                    }}
                    text1="Your order is placed successfully. It will be processed subject to the realization of payment."
                    text2="Click here to view details."
                    product={product}
                    isMobile={isMobile}
                  />
                }
              </>
            );
          }
          if (
            userState.obUserApproved &&
            userState.obPaymentDone &&
            userState.obOrderApproved
          ) {
            return (
              <StateCardBasic
                img={done}
                state="done"
                cta="Invest now"
                userState={userState}
                onClick={() => {
                  scrollToSection(txnRef);
                }}
                text1="Congratulations! Your order is processed, and it will reflect in 3 working days."
                text2="Click here to view details."
                product={product}
                isMobile={isMobile}
              />
            );
          }
          if (userState.obPaymentDone && userState.obOrderRejected) {
            return (
              <StateCardBasic
                img={failed}
                state="failed"
                cta="Try Again"
                userState={userState}
                onClick={() => {
                  scrollToSection(investSectionRef);
                }}
                text1={assetDetails.userInRfqCug ? "Payment Link Generation Failed." : "Sorry, your order is rejected. Any amount debited will be refunded within 3-5 working days."}
                text2={assetDetails.userInRfqCug ? "There seems to be some technical issue. Please retry payment" : "Click here to place a new order."}
                product={product}
                isMobile={isMobile}
              />
            );
          }
          if (userState.obUserNotInvested) {
            return (
              <StateCardBasic
                img={done}
                state="done"
                cta="Invest now"
                userState={userState}
                onClick={() => {
                  scrollToSection(investSectionRef);
                }}
                text1="Congratulations! Your KYC is verified."
                text2="Click here to start Investing."
                product={product}
                isMobile={isMobile}
              />
            );
          }
        } else {
          if (errors.length || (thirdPartyData.userInHypervergeCug && thirdPartyData.enhancedKycStaus === 'rejected')) {
            return (
              <StateCardBasic
                img={failed}
                state="failed"
                cta="Complete your KYC"
                userState={userState}
                onClick={() => {
                  setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                  initBranch().then(() => {
                    trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                  }).catch(error => console.error('Error initializing Branch:', error));
                  ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
                  if (thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC) {
                    if (window.ReactNativeWebView) {
                      window.ReactNativeWebView.postMessage(
                        JSON.stringify({ 
                          action: "BIDD_HV", 
                          data: {
                            assetCode: assetDetails?.product,
                            productType: assetDetails?.productType
                          }
                        })
                      )
                    } else {
                      return hypervergeVerification();
                    }
                  } else if(!thirdPartyData.userInHypervergeCug) {
                    window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-docvault"
                  }
                }}
                text1="Your KYC is rejected."
                text2="Click here to re-upload your documents."
                product={product}
                isMobile={isMobile}
              />
            );
          }
          return (
            <StateCardBasic
              img={null}
              state="pending"
              cta="View KYC"
              userState={userState}
              onClick={() => {
                setAnalyticsEvent("Bidd_Assest_Page_KYC_Banner", product);
                initBranch().then(() => {
                  trackEvent(`Bidd_Assest_Page_KYC_Banner`, product);
                }).catch(error => console.error('Error initializing Branch:', error))
                ReactPixel.track("Bond_Kyc_Start_Pixel", {email: thirdPartyData?.email || ""});
                if (thirdPartyData.userInHypervergeCug && thirdPartyData.forceKYC) {
                  if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify({ 
                        action: "BIDD_HV", 
                        data: {
                          assetCode: assetDetails?.product,
                          productType: assetDetails?.productType
                        }
                      })
                    )
                  } else {
                    return hypervergeVerification();
                  }
                } else {
                  return
                }
              }}
              text1="Thank you for sharing your details, your KYC is under verification."
              // text2="here."
              product={product}
              isMobile={isMobile}
            />
          );
        }
      }
    }
  };

  const setUnitsFunc = (val) => {
    const result = val.replace(/[^0-9]/g, "");
    setUnits(Number(result));
  };

  const scrollToSection = useCallback((ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [investSectionRef]);

  const toggleFailedBse = () => {
    setPopUpFailedBse(!popUpFailedBse)
  }

  const openModal = (val) => {
    setCurrYield(val);
    setShowYTM(true);
  }
  const determineAsssetPage = (productType) => {
    switch (productType) {
      case "bonds":

        return <BondsAsset
          isAdvisory={isAdvisory}
          oroLoader={oroLoader}
          isOngoingOrder={isOngoingOrder}
          // getUserStateBanner={getUserStateBanner}
          loader={loader}
          portfolioValue={portfolioValue}
          isMobile={isMobile}
          assetDetails={assetDetails}
          realisedCouponsSum={realisedCouponsSum}
          closeYTMModal={closeYTMModal}
          showYTM={showYTM}
          // setShowYTM={setShowYTM}
          openModal={openModal}
          investSectionRef={investSectionRef}
          isDisable={isDisable}
          productDetails={productDetails}
          product={product}
          priceResponse={priceResponse}
          setShowFAQ={setShowFAQ}
          decreaseUnits={decreaseUnits}
          units={units}
          setUnitsFunc={setUnitsFunc}
          increaseUnits={increaseUnits}
          // setShowCleanPrice={setShowCleanPrice}
          cleanUpPrice={cleanUpPrice}
          setShowMonthlyPayment={setShowMonthlyPayment}
          totalPayout={totalPayout}
          setShowPayment={setShowPayment}
          // openShowOfferBenefit={openShowOfferBenefit}
          startInvest={startInvest}
          maxAmt={maxAmt}
          isNewJourney={isNewJourney}
          errors={errors}
          userState={userState}
          showMonthlyPayment={showMonthlyPayment}
          couponsPer1k={couponsPer1k}
          closeMonthlyPaymentModal={closeMonthlyPaymentModal}
          Coupons={Coupons}
          totalCoupons={totalCoupons}
          transactions={transactions}
          txnRef={txnRef}
          scrollToSection={scrollToSection}
          isTxnAllowed={isTxnAllowed}
          bondDetails={bondDetails}
          // redirectProspectus={redirectProspectus}
          showFAQ={showFAQ}
          closeFAQModal={closeFAQModal}
          showCleanPrice={showCleanPrice}
          closeCleanPriceModal={closeCleanPriceModal}
          showPayment={showPayment}
          closePaymentModal={closePaymentModal}
          currYield={currYield}
          showOfferBenefit={showOfferBenefit}
          closeShowOfferBenefit={closeShowOfferBenefit}
          isUserApproved={userState?.obUserApproved}
          showConsultbanner={props?.showConsultbanner}
          closeConsultBanner={props?.closeConsultBanner}
          ucc={ucc}
          inputValueError={inputValueError}
          minUnit={minUnit}
          isUserObInvested={props?.isUserObInvested}
          isKycDone={isKycDone}
          thirdPartyData={thirdPartyData}
          isModalOpen={isModalOpen}
          toggleHvInitiateModal={toggleHvInitiateModal}
          hypervergeVerification={hypervergeVerification}
          loaderHyperverge={loaderHyperverge}
          cvlValidate={cvlValidate}
          email={thirdPartyData?.email}
          // cashfreeDoPayment={cashfreeDoPayment}
        />
      case "mld":
        return <MldAssets
          isAdvisory={isAdvisory}
          mldAssetDetails={mldDetails}
          goToPaymentOverview={goToPaymentOverview}
          startInvest={startInvest}
          isNewJourney={isNewJourney}
          showConsent={showConsent}
          units={units}
          decreaseUnits={decreaseUnits}
          setUnitsFunc={setUnitsFunc}
          increaseUnits={increaseUnits}
          transactions={transactions}
          txnRef={txnRef}
          isMobile={isMobile}
          portfolioValue={portfolioValue}
          investSectionRef={investSectionRef}
          scrollToSection={scrollToSection}
          isOngoingOrder={isOngoingOrder}
          loader={loader}
          errors={errors}
          userState={userState}
          priceResponse={priceResponse}
          isKycDone={isKycDone}
          showConsultbanner={props?.showConsultbanner}
          closeConsultBanner={props?.closeConsultBanner}
          productDetails={productDetails}
          product={product}
          thirdPartyData={thirdPartyData}
          cvlValidate={cvlValidate}
          isModalOpen={isModalOpen}
          toggleHvInitiateModal={toggleHvInitiateModal}
          hypervergeVerification={hypervergeVerification}
        />

      case "ipo":
        return <IpoAssetNew
          ipoAssetDetails={assetDetails}
          goToPaymentOverview={goToPaymentOverview}
          startInvest={startInvest}
          isNewJourney={isNewJourney}
          showConsent={showConsent}
          units={units}
          decreaseUnits={decreaseUnits}
          setUnitsFunc={setUnitsFunc}
          increaseUnits={increaseUnits}
          transactions={transactions}
          txnRef={txnRef}
          isMobile={isMobile}
          portfolioValue={portfolioValue}
          investSectionRef={investSectionRef}
          scrollToSection={scrollToSection}
          isOngoingOrder={isOngoingOrder}
          loader={loader}
          errors={errors}
          userState={userState}
          recallTransaction={recallTransaction}
          priceResponse={priceResponse}
          isKycDone={isKycDone}
          showConsultbanner={props?.showConsultbanner}
          closeConsultBanner={props?.closeConsultBanner}
          productDetails={productDetails}
          product={product}
        />
    }
  }

  return (
    <div className="navi-asset-detail-main"
      style={isMobile ? { marginTop: "3.1rem" } : { marginTop: "-0.2rem" }}>
      {!oroLoader && !openPaymentMode ?
        !isOngoingOrder && (
          <>
            {isTpdLoaded && thirdPartyData.userInHypervergeCug && thirdPartyData.enhancedKycStaus !== "approved" && !loaderHyperverge ? getUserStateBannerHvUser() : !loaderHyperverge ? getUserStateBanner() : null}
            {!loader &&
              (portfolioValue &&
              portfolioValue.data &&
              portfolioValue.data.pfStats && !openPaymentMode && !succesModal &&
              portfolioValue.data.pfStats.investedAmt && !isAdvisory) ? (
              !isMobile ? (
                <InvestmentOverviewMain
                  portfolioValue={portfolioValue}
                  assetDetails={assetDetails}
                  Coupons={pfCoupon}
                  realisedCouponsSum={realisedCouponsSum}
                  closeYTMModal={closeYTMModal}
                  showYTM={showYTM}
                  setShowYTM={setShowYTM}
                  openModal={openModal}
                  productType={productType}
                  productName={product}
                />
              ) : (
                <InvestmentOverviewMainMob
                  portfolioValue={portfolioValue}
                  assetDetails={assetDetails}
                  Coupons={pfCoupon}
                  realisedCouponsSum={realisedCouponsSum}
                  closeYTMModal={closeYTMModal}
                  showYTM={showYTM}
                  setShowYTM={setShowYTM}
                  openModal={openModal}
                  productType={productType}
                  productName={product}
                  isRedemptionAllowed={assetDetails?.isRedemptionAllowed}
                />
              )
            ) : (
              ""
            )}
          </>
        ) : null}
      {
        cashfreePaymentStatusPopup &&
        <CashfreePaymentStatus
        investmentAmount={investmentAmount}
          data={cashfreePaymentStatusPopupData}
          // status={"success"}
          isOpen={cashfreePaymentStatusPopup}
          setpaymentMethod={setpaymentMethod}
          toggleModal={(res) => {
            setCashfreePaymentStatusPopup(res);
            if (!res) {
              setCashfreePaymentStatusPopupData(null);
            }
          }}
          retrySubmitOrderAtExchange={fnSendToExchange}
          isAdvisory={isAdvisory}
          redirectToPartner={redirectToPartner}
          product={product}
          thirdPartyData={thirdPartyData}
        // title={"Payment Success"}
        // statusMessage={"Initiating Order at NSE<br/>Please wait "}
        // note={"Do not close the browser"}
        // showBtnClose={false}
        />
      }
      {!openPaymentMode ? determineAsssetPage(productType) : (
        (order && order.userAmount && (!ucc?.bse?.uccCreated || !assetDetails?.userInRfqCug)) &&
        <SelectPaymentMode
          openPaymentMode={openPaymentMode}
          togglePaymentMode={togglePaymentMode}
          paymentMethod={paymentMethod}
          onPaymentChange={onPaymentChange}
          gobackPaymentMode={gobackPaymentMode}
          userAmount={order?.userAmount}
        />
      )}
      {(openPaymentMode && ucc?.[exchange]?.uccCreated && assetDetails?.userInRfqCug && !isAdvisory) ?
        <SelectPaymentModeRfq
          openPaymentMode={openPaymentMode}
          togglePaymentMode={togglePaymentMode}
          setpaymentMethod={setpaymentMethod}
          paymentMethod={paymentMethod}
          transactionStartTime={transactionStartTime}
          togglePriceDifferencePopUp={togglePriceDifferencePopUp}
          onPaymentChange={onPaymentChange}
          gobackPaymentMode={gobackPaymentMode}
          canclePaymentModelRfq={canclePaymentModelRfq}
          userAmount={
            get(investmentAmount, "userAmount", 0)
              ? get(investmentAmount, "userAmount", 0)
              : 0
          }
          // priceValidityTime={"15:59"}
          priceValidityTime={get(investmentAmount, "priceValidityTime", 0)
            ? get(investmentAmount, "priceValidityTime", 0)
            : 0
          }
          recordDate = {priceResponse?.futureCoupons[0]?.cutOffDate}
          loaderForNEFT={loaderForNEFT}
          thirdPartyData={thirdPartyData}
          paymentTried={paymentTried}
          paymentLinkLoader={paymentLinkLoader}
          exchange={exchange}
        /> : null}
        {openRfqFailedPopUp ? <FailPopUpRfq
        openRfqFailedPopUp={openRfqFailedPopUp}
        toggleRfqFailedPopUp={toggleRfqFailedPopUp}
         /> : null}
      {succesModal && !isAdvisory ? (
        <SuccessFailureModal
          isOpen={succesModal}
          modalType={modalType}
          statusMessage={statusMessage}
          paymentLinkRes={paymentLinkRes}
          toggleModal={toggleSuccesModal}
          status={modalType === "payment" ? paymentStatus : signatureStatus}
        />
      ) : null}

      {openNeftRtgs ? (
        <NeftRtgsDetails
          openNeftRtgs={openNeftRtgs}
          toggleNeftRtgs={toggleNeftRtgs}
          showInstruction={showInstruction}
          amount={order && order.userAmount}
          neftPaymentSuccess={neftPaymentSuccess}
          product={product}
          ucc={ucc?.bse?.uccCreated}
          isAdvisory={isAdvisory}
          userInRfq={assetDetails?.userInRfqCug}
          loaderForNEFT={loaderForNEFT}
          paymentTried={paymentTried}
          paymentLinkLoader={paymentLinkLoader}
          subPartnerRedirectUrl={subPartnerRedirectUrl}
          cashfreeOrderId={cashfreeOrderId}
        />
      ) : null}

      {showConsent ? (
        <ConsentPopup
          isMobile={isMobile}
          isOpen={showConsent}
          goToPaymentOverview={startInvestingFlow}
          toggle={() => setShowConsent(!showConsent)}
          product={product}
        />
      ) : null}
      {
        <BseFailedPopUp
          showPopUpText={popUpFailedBse}
          toggleInfoPopup={toggleFailedBse}
        />
      }
      {paymentModalOpen && (
        <NaviPaymentDetails
          irr={
            get(assetDetails, "xirr", "")
              ? get(assetDetails, "xirr", "") + "%"
              : ""
          }
          oppName={oppName}
          productname={productDetails?.displayName}
          thirdPartyData={thirdPartyData}
          paymentModalOpen={paymentModalOpen}
          togglePaymentModal={togglePaymentModal}
          demat={get(thirdPartyData, "demat", "")}
          units={get(investmentAmount, "units", "")}
          isTxnAllowed={get(investmentAmount, "isTxnAllowed", "")}
          userAmount={
            get(investmentAmount, "userAmount", 0)
              ? get(investmentAmount, "userAmount", 0).oroNumber(2, true)
              : 0
          }
          benefitPerc={get(investmentAmount, "benefit", 0).toFixed(1) + "%"}
          benefit={
            get(investmentAmount, "oroAmount", 0)
              ? get(investmentAmount, "oroAmount", 0)
              : 0
          }
          referralBenefit={
            get(investmentAmount, "referralBenefits", {})
              ? (get(investmentAmount, "referralBenefits", {}).discountForReferal || 0)
              : 0
          }
          amount={
            get(investmentAmount, "userAmount", 0)
              ? (get(investmentAmount, "userAmount", 0)).oroNumber(2, true)
              : 0
          }
          custId={get(userProfile, "custId", "")}
          pan={dematPan}
          product={product}
          isin={productDetails.ISIN}
          logoUrl={productDetails.logoUrl}
          userEmail={props.userEmail}
          ytm={get(priceResponse, "ytm", "") ? get(priceResponse, "ytm", "").toFixed(2) : ""}
          ucc={ucc}
          investmentAmount={investmentAmount}
          cug={
            get(assetDetails, "cugMode", "")
              ? get(assetDetails, "cugMode", "")
              : ""
          }
          openPaymentRtgs={openPaymentRtgs}
          userInRfqCug={assetDetails?.userInRfqCug}
          rfqExchangeType={exchange}
        />
      )}
      {
        priceChangePopup ? 
        <PriceDifferenceAlert
          priceChangePopup={priceChangePopup}
          togglePriceDifferencePopUp={togglePriceDifferencePopUp}
        /> 
        : null
      }
      {hypervergeSuccess ?
        <HypervergeSuccessPopUp
        errorsHyperverge={errorsHyperverge}
        toggleHypervergeSuccess={toggleHypervergeSuccess}
        reInitiateHyperverge={reInitiateHyperverge}
        hypervergeSuccess={hypervergeSuccess} /> :
        null
      }
      {hypervergeFailure ? 
      <HypervergeFailurePopUp
      toggleHypervergeFailure={toggleHypervergeFailure}
      hypervergeFailure={hypervergeFailure} /> : null}

      {userCancelled ? 
      <HypervergeUserCancelPopUp
      toggleUserCancelled={toggleUserCancelled}
      reInitiateHyperverge={reInitiateHyperverge}
      userCancelled={userCancelled}/> : null}

      {
        isUccNse.popup &&
        <PopupUccNseError data={isUccNse.failed}
          toggleModal={(res) => {
            setIsUccNse({
              ...isUccNse,
              popup: false
            })
          }}
          isAdvisory={isAdvisory}
          redirectToPartner={redirectToPartner}
        />
      }
    </div>
  )
});

export default OrobondsAsset;
